/**
 * Accessibility fix: Change all star (*) symbols to read "Required" on WooCommerce forms.
 */
(() => {
    function changeRequiredMarkup() {
        document
            .querySelectorAll('.woocommerce form .form-row .required')
            .forEach((required) => {
                required.innerHTML = '(' + h_woocommerce.required + ')';
            });
    }

    changeRequiredMarkup();

    /**
     * WooCommerce has some brilliant feature to (re)set the star symbols via JavaScript on the
     * address form (in My Account) for some fields. To make this fix for those fields, I'm just
     * being lazy and resetting them again after a timeout.
     *
     * Ideally that feature should be disabled and then this would not be needed.
     */
    setTimeout(changeRequiredMarkup, 1000);
})();
